import { render } from "./diamondsSearchResultLoading.vue?vue&type=template&id=56241392&scoped=true"
const script = {}

import "./diamondsSearchResultLoading.vue?vue&type=style&index=0&id=56241392&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56241392"]])

export default __exports__